module.exports = __webpack_public_path__ + "img/dots_gray.577be81e.svg";